import {
  CertificateDetails,
  CredentialFamily,
  DocumentDetails,
  IdentificationDetails,
  PartialCredInfo,
} from "./types";

export type GenericCredentialDetails =
  | { [key: string]: string }
  | IdentificationDetails
  | CertificateDetails
  | DocumentDetails;

/**
 *
 * @param params inputOne and inputTwo
 * @param credInfo - other needed params
 * @returns
 */
export function formatDynamicAddCredAPIParams(
  params: Partial<GenericCredentialDetails>,
  credInfo: PartialCredInfo
): Partial<GenericCredentialDetails> {
  switch (credInfo.credentialFamily) {
    case CredentialFamily.CERTIFICATE:
      return formatDynamicAddCertParams(params, credInfo);
    case CredentialFamily.IDENTIFICATION:
      return formatDynamicAddIDParams(params, credInfo);
    case CredentialFamily.DOCUMENT:
      return formatDynamicAddDocParams(params, credInfo);
  }
}

function formatDynamicAddCertParams(
  params: Partial<CertificateDetails>,
  credInfo: PartialCredInfo
): CertificateDetails {
  const outputParams: CertificateDetails = {
    ...params,
    certificateType: credInfo.credentialType,
    title: credInfo.title,
  };
  return outputParams;
}

function formatDynamicAddIDParams(
  params: Partial<IdentificationDetails>,
  credInfo: PartialCredInfo
): IdentificationDetails {
  const outputParams: IdentificationDetails = {
    ...params,
    identificationType: credInfo.credentialType,
    title: credInfo.title,
  };
  return outputParams;
}

function formatDynamicAddDocParams(
  params: Partial<DocumentDetails>,
  credInfo: PartialCredInfo
): DocumentDetails {
  const outputParams: DocumentDetails = {
    ...params,
    documentType: credInfo.credentialType,
    title: credInfo.title,
  };
  return outputParams;
}

/**
 *
 * @param params inputOne and inputTwo
 * @param credInfo - other needed params
 * @returns
 */
export function formatDynamicEditCredAPIParams(
  params: Partial<GenericCredentialDetails>,
  credInfo: PartialCredInfo
): GenericCredentialDetails {
  switch (credInfo.credentialFamily) {
    case CredentialFamily.CERTIFICATE:
      return formatDynamicEditCertParams(params, credInfo);
    case CredentialFamily.IDENTIFICATION:
      return formatDynamicEditIDParams(params, credInfo);
    case CredentialFamily.DOCUMENT:
      return formatDynamicEditDocParams(params, credInfo);
  }
}

function formatDynamicEditCertParams(
  params: Partial<CertificateDetails>,
  credInfo: PartialCredInfo
): CertificateDetails {
  const outputParams: CertificateDetails = {
    ...params,
    certificateType: credInfo.credentialType,
    title: credInfo.title,
  };
  return outputParams;
}

function formatDynamicEditIDParams(
  params: Partial<IdentificationDetails>,
  credInfo: PartialCredInfo
): IdentificationDetails {
  const outputParams: IdentificationDetails = {
    ...params,
    identificationType: credInfo.credentialType,
    title: credInfo.title,
  };
  return outputParams;
}

function formatDynamicEditDocParams(
  params: Partial<DocumentDetails>,
  credInfo: PartialCredInfo
): DocumentDetails {
  const outputParams: DocumentDetails = {
    ...params,
    documentType: credInfo.credentialType,
    title: credInfo.title,
  };
  return outputParams;
}
